import { Directive, forwardRef, Attribute, Input } from '@angular/core';
import { NG_VALIDATORS, ValidationErrors, AbstractControl, Validator } from '@angular/forms';

@Directive({
    selector: '[validateNumber], [validateMax], [validateMin]',
    standalone: true,
    providers: [{ provide: NG_VALIDATORS, useExisting: forwardRef(() => ValidateNumberDirective), multi: true }]
})
export class ValidateNumberDirective implements Validator {
    @Input({
        transform: (value: string | number | undefined) => {
            return typeof value === 'string' ? parseFloat(value) : value;
        }
    })
    validateMax?: number;

    @Input({
        transform: (value: string | number | undefined) => {
            return typeof value === 'string' ? parseFloat(value) : value;
        }
    })
    validateMin?: number;

    /**
     * Validation method
     * @param {AbstractControl} control
     * @returns {ValidationErrors | null}
     */
    validate(control: AbstractControl): ValidationErrors | null {
        let value = control.value;
        if (typeof value == 'string') {
            value = parseFloat(value);
        }
        if (typeof value === 'number') {
            if (this.checkMin(value)) {
                return {
                    ['numberMin']: false
                };
            }

            if (this.checkMax(value)) {
                return {
                    ['numberMax']: false
                };
            }
        }
        return null;
    }

    private checkMin(value: number): boolean {
        if (this.validateMin) {
            return value < this.validateMin;
        }
        return false;
    }

    private checkMax(value: number): boolean {
        if (this.validateMax) {
            return value > this.validateMax;
        }
        return false;
    }
}
